var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"def-label m-l-xs font-11 b-radius-3px"},[_c('i',{staticClass:"fal m-l-xxs m-r-xxs fa-fw",class:_vm.iconClass}),_vm._v(" "+_vm._s(_vm.canal || 'Email')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }